( function ( $ ) {
	var $cat_item = $(".cat-item");
	var $cat_children = $(".cat-item > .children");
	var $cat_ancestor = $(".current-cat-ancestor");
	var $cat_current = $(".cat-item.current-cat");
	var $primary_nav = $('.primary-navigation');


	$(document).ready(function () {
		$cat_children.css('display', 'none');
		$cat_ancestor.add($cat_current).children(".children").css('display', 'block');
		$cat_ancestor.add($cat_current).addClass("open");

		$cat_item.each(function(){
			if($(this).find("ul.children").length !== 0) {
				$(this).on("click", function (e){
					e.stopPropagation();
					$(this).toggleClass("open");
					$(this).children(".children").slideToggle();
				});
			} else {
				$(this).addClass("no-children");
			}
		});
	});

	$cat_item.children("a").click(function(e) {
		e.stopPropagation();
	});

	if ($(window).width() < 768) {
		$primary_nav.addClass("handheld-navigation");
	}

} )( jQuery );
